namespace AgerLMS.LMS {
    export interface FtpUploadFile {
        FileName?: string;
        FilePath?: string;
        CreationTime?: string;
        LastWriteTime?: string;
    }
}
